import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "tab-pane fade",
  id: "address",
  role: "tabpanel"
}
const _hoisted_2 = { class: "card mt-5 mb-xl-10" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "row gx-9 gy-6" }
const _hoisted_5 = { class: "card card-dashed p-2 px-4" }
const _hoisted_6 = { class: "d-flex flex-column py-2" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-2" }
const _hoisted_9 = {
  key: 0,
  class: "badge badge-light-primary fs-7"
}
const _hoisted_10 = {
  key: 1,
  class: "badge badge-light-success fs-7"
}
const _hoisted_11 = { class: "col-2" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "fw-bold fs-6 text-gray-800" }
const _hoisted_14 = { class: "col-1" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "fw-bold fs-6 text-gray-800" }
const _hoisted_17 = { class: "col-3" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "fw-bold fs-6 text-gray-800" }
const _hoisted_20 = { class: "col-4" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = { class: "fw-bold fs-6 text-gray-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("div", { class: "card-title" }, [
          _createElementVNode("h3", null, "Address")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vendor.Addresses, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "col-12"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _cache[0] || (_cache[0] = _createElementVNode("label", { class: "fw-semibold text-muted" }, "Type", -1)),
                      _createElementVNode("div", null, [
                        (item.Type === _ctx.AddressType.DELIVERY)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.Type), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(item.Type), 1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[1] || (_cache[1] = _createElementVNode("label", { class: "fw-semibold text-muted" }, "Postal Code", -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(item.PostalCode), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _cache[2] || (_cache[2] = _createElementVNode("label", { class: "fw-semibold text-muted" }, "Line 1", -1)),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(item.Line1), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[3] || (_cache[3] = _createElementVNode("label", { class: "fw-semibold text-muted" }, "Line 2", -1)),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(item.Line2), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[4] || (_cache[4] = _createElementVNode("label", { class: "fw-semibold text-muted" }, "City", -1)),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString(item.City) + ", " + _toDisplayString(item.Region), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}